export default __webpack_public_path__ + "aa89df2d988cdf4516b25cff942cc2c4.svg";